import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  IconButton,
  Icon,
  ListItemIcon,
  ListSubheader,
  CircularProgress,
  Menu,
  MenuItem,
  Divider,
  Tooltip,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
  CheckBoxOutlineBlank,
  CheckCircle,
  Update,
} from '@mui/icons-material';

import {
  patchEvent,
  changeStatus,
} from '@pingum/app-state-management/event/actions';

import styles from './styles';

export class TaskActionsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      element: null,
      isLoading: false,
    };
  }

  handleOpen = (e) => {
    this.setState({
      open: true,
      element: e.currentTarget,
    });
    e.stopPropagation();
  }

  handleClose = (e) => {
    this.setState({
      open: false,
      element: null,
    });
    e.stopPropagation();
  }

  handleArchiveEvent = (request, e) => {
    this.setState({ isLoading: true });
    this.props.patchEvent(this.props.task.id, request).then(() => {
      this.setState({ isLoading: false })
    });
    this.handleClose(e);
  }

  handleEventStatus = (request, e) => {
    this.setState({ isLoading: true });
    this.props.patchEvent(this.props.task.id, request).then(() => {
      const statusId = request.completeEvent
        ? this.props.selectedBarn.barnMetadata.statusEndId
        : this.props.selectedBarn.barnMetadata.statusPendingId;
      this.props.changeStatus(this.props.task.id, {
        statusId: parseInt(statusId, 10),
        statusComment: null,
        completeEvent: request.completeEvent,
        assignment: (this.props.task.currentEventStatus && this.props.task.currentEventStatus.assignment) || '',
      }).then(() => {
        this.setState({ isLoading: false })
      })
    });
    this.handleClose(e);
  }

  render() {
    const {
      task: event,
      isUpdatingEvent,
      openEventDetailsPage,
      openHistoryDialog,
      prominentComplete,
    } = this.props;
    const {
      element,
      open,
      isLoading,
    } = this.state;

    return (
      <div>
        {
          (isUpdatingEvent && isLoading)
            ? <CircularProgress size={30} />
            : (
              <>
                {
                  prominentComplete && (
                    event.completeDate
                      ? (
                        <Tooltip title="Reactivate Task">
                          <IconButton
                            disabled={isUpdatingEvent}
                            onClick={(e) => {
                              this.handleEventStatus({ completeEvent: false }, e);
                            }}
                            id="menu-btn"
                            aria-owns={open
                              ? 'menu-appbar'
                              : null}
                            aria-haspopup="true"
                            size="small"
                          >
                            <Update />
                          </IconButton>
                        </Tooltip>
                      )
                      : (
                        <Tooltip title="Complete Task">
                          <IconButton
                            disabled={isUpdatingEvent}
                            onClick={(e) => {
                              this.handleEventStatus({ completeEvent: true }, e);
                            }}
                            id="menu-btn"
                            aria-owns={open
                              ? 'menu-appbar'
                              : null}
                            aria-haspopup="true"
                          >
                            <CheckBoxOutlineBlank />
                          </IconButton>
                        </Tooltip>
                      )
                  )
                  }
                <IconButton
                  disabled={isUpdatingEvent}
                  onClick={this.handleOpen}
                  id="menu-btn"
                  aria-owns={open
                    ? 'menu-appbar'
                    : null}
                  aria-haspopup="true"
                >
                  <Icon>more_vert</Icon>
                </IconButton>
              </>
            )
        }
        <Menu
          id="menu-appbar"
          anchorEl={element}
          open={open}
          onClose={this.handleClose}
        >
          <ListSubheader>Actions</ListSubheader>

          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              this.handleClose(e);
              openHistoryDialog();
            }}
          >
            <ListItemIcon>
              <Icon>skip_next</Icon>
            </ListItemIcon>
            Change Status &amp; Assign
          </MenuItem>
          {
            event.completeDate
              ? (
                <MenuItem
                  onClick={(e) => {
                    this.handleEventStatus({ completeEvent: false }, e);
                  }}
                >
                  <ListItemIcon>
                    <Update />
                  </ListItemIcon>
                  Reactivate
                </MenuItem>
              )
              : (
                <MenuItem
                  onClick={(e) => {
                    this.handleEventStatus({ completeEvent: true }, e);
                  }}
                >
                  <ListItemIcon>
                    <CheckCircle />
                  </ListItemIcon>
                  Complete
                </MenuItem>
              )
          }
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              this.handleClose(e);
              openEventDetailsPage();
            }}
          >
            <ListItemIcon>
              <Icon>edit</Icon>
            </ListItemIcon>
            Edit
          </MenuItem>

          <Divider />
          {
            event.archived
              ? (
                <MenuItem
                  onClick={(e) => {
                    this.handleArchiveEvent({ archived: false }, e);
                  }}
                >
                  <ListItemIcon>
                    <Icon>restore_from_trash</Icon>
                  </ListItemIcon>
                  Restore
                </MenuItem>
              )
              : (
                <MenuItem
                  onClick={(e) => {
                    this.handleArchiveEvent({ archived: true }, e);
                  }}
                >
                  <ListItemIcon>
                    <Icon>delete</Icon>
                  </ListItemIcon>
                  Delete
                </MenuItem>
              )
          }
        </Menu>
      </div>
    );
  }
}

TaskActionsComponent.propTypes = {
  task: PropTypes.object,
  isUpdatingEvent: PropTypes.bool,
  patchEvent: PropTypes.func,
  changeStatus: PropTypes.func,
  openEventDetailsPage: PropTypes.func,
  openHistoryDialog: PropTypes.func,
  prominentComplete: PropTypes.bool,
  selectedBarn: PropTypes.object,
};

TaskActionsComponent.defaultProps = {
  task: {},
  isUpdatingEvent: false,
  patchEvent: () => {},
  changeStatus: () => {},
  openEventDetailsPage: () => {},
  openHistoryDialog: () => {},
  prominentComplete: false,
  selectedBarn: {},
};

export const mapStateToProps = (state) => ({
  isUpdatingEvent: state.event.isUpdatingEvent,
  selectedBarn: state.barn.selectedBarn,
});

export const mapDispatchToProps = (dispatch) => ({
  patchEvent: (id, request) => dispatch(patchEvent(id, request)),
  changeStatus: (id, request) => dispatch(changeStatus(id, request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(TaskActionsComponent));
